import React, { Component } from 'react'
import { Row, Col, Card } from 'antd'
import { StatFileIcon, StatCheckIcon } from './Icons'

const OnlineGlobeIcon = (props) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
)

// 📰 SVG Icon for Published Article
const PublishedArticleIcon = (props) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </svg>
)

class StatsCards extends Component {
  render() {
    const { data } = this.props;

    // Card 1: Total manuscripts received
    const totalCount = (data && data.totalSubmissions && data.totalSubmissions.count !== undefined)
      ? data.totalSubmissions.count.toLocaleString()
      : '0';

    // Card 2: Accepted manuscripts
    const acceptedCount = (data && data.accepted && data.accepted.count !== undefined)
      ? data.accepted.count.toLocaleString()
      : '0';

    // Card 3: Online Published (Status: 'Online Publish')
    const onlinePublishedObj = data && (data['Online Publish'] || data.onlinePublish || data.onlinePublished);
    const onlinePublishedCount = (onlinePublishedObj && onlinePublishedObj.count !== undefined)
      ? onlinePublishedObj.count.toLocaleString()
      : '0';

    // Card 4: Published Article (Status: 'Published Article')
    const publishedArticleObj = data && (data['Published Article'] || data.publishedArticle || data.sendForPublicationDate);
    const publishedArticleCount = (publishedArticleObj && publishedArticleObj.count !== undefined)
      ? publishedArticleObj.count.toLocaleString()
      : '0';

    // Trend calculations for total manuscripts
    const totalTrend = (data && data.totalSubmissions && data.totalSubmissions.trend !== undefined)
      ? data.totalSubmissions.trend
      : 12.4;

    const trendSymbol = totalTrend > 0 ? '+' : '';
    const changeText = `${trendSymbol}${totalTrend}%`;
    const trendDirection = totalTrend >= 0 ? 'up' : 'down';

    const statsData = [
      {
        Icon: StatFileIcon,
        value: totalCount,
        label: 'Total manuscripts received',
        // change: changeText,
        trend: trendDirection,
        iconClass: 'icon-green'
      },
      {
        Icon: StatCheckIcon,
        value: acceptedCount,
        label: 'Accepted manuscripts',
        // change: '+8.6%',
        trend: 'up',
        iconClass: 'icon-blue'
      },
      {
        Icon: OnlineGlobeIcon,
        value: onlinePublishedCount,
        label: 'Online Published',
        change: null, // Comparison removed
        iconClass: 'icon-orange'
      },
      {
        Icon: PublishedArticleIcon,
        value: publishedArticleCount,
        label: 'Published Article',
        change: null, // Comparison removed
        iconClass: 'icon-gold'
      }
    ];

    return (
      <Row gutter={15} className={'statsCardRow'}>
        {statsData.map((item, key) => (
          <Col key={key} lg={6} md={12} sm={12} xs={24}>
            <Card className={'statCard'}>
              <div className={'statCardTop'}>
                <div className={`statIconWrap ${item.iconClass}`}>
                  <item.Icon style={{ width: 20, height: 20 }} />
                </div>
                {item.change && (
                  <div className={`statChange ${item.trend === 'up' ? 'statChangeUp' : 'statChangeDown'}`}>
                    {item.change}
                  </div>
                )}
              </div>
              <div className={'statValue'}>{item.value}</div>
              <div className={'statLabel'}>{item.label}</div>
            </Card>
          </Col>
        ))}
      </Row>
    )
  }
}

export default StatsCards;